import { useForm } from "react-hook-form";
import { Box, VStack, Heading, Button, Text } from '@bpba/ui-components';
import { Input, Select, IOption, TextArea, BPFormType } from '@bpba/form-components';
import { useEnviarConsulta } from '../hooks/useEnviarConsulta';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from "react";
import { Modal } from './shared/modal/Modal';
import { formatearFechaISO } from "../utils/ajusteDatosBackend";
import { LoadingComponent } from "./shared/LoadingComponent";

export const ConsultaUsuarioInmuebleComponent = () => {

    const methods = useForm<any>({ mode: 'onChange', criteriaMode: 'all', reValidateMode: 'onChange' });
    const { handleSubmit, control, setValue, clearErrors, reset } = methods;
    const { submit, loading, success, error } = useEnviarConsulta();

    const location = useLocation();
    const idInmueble = location.state?.idInmueble;

    const navigate = useNavigate();

    const [openModal, setOpenModal] = useState(false);

    useEffect(() => {
        if (success || error) {
            setOpenModal(true);
        }

        if (success) {
            reset();
        }
    }, [success, error]);

    if (!idInmueble) {
        return <Text>Error: no se pudo determinar el inmueble</Text>;
    }

    const onSubmit = (data: any) => {
        const payload = {
            fecha: new Date().toISOString(),
            inmueble: idInmueble,

            apeNom: data.nombreApellido,
            tipoDoc: Number(data.tipoDoc.id),
            nroDoc: Number(data.dni),

            sexo: Number(data.sexo.id),
            fechaNac: formatearFechaISO(data.fechaNac),

            telFijo: data.nroFijo,
            celular: data.celular,
            email: data.email,

            horaContDDe: Number(data.hsContactoDesde.label),
            horaContHHa: Number(data.hsContactoHasta.label),

            consulta: data.mensaje,
            medioPrefContacto: data.medioDeContacto,

            clienteBanco: data.siClienteBanco,
            recibeEmails: data.siNovedades
        };

        submit(payload);
    };

    const hsContacto: IOption[] = [
        {
            id: '1',
            label: '10',
        },
        {
            id: '2',
            label: '11',
        },
        {
            id: '3',
            label: '12',
        },
        {
            id: '4',
            label: '13',
        },
        {
            id: '5',
            label: '14',
        },
        {
            id: '6',
            label: '15',
        },
        {
            id: '7',
            label: '16',
        },
        {
            id: '8',
            label: '17',
        },
        {
            id: '9',
            label: '18',
        },
        {
            id: '10',
            label: '19',
        },
        {
            id: '11',
            label: '20',
        },
    ];

    const tipoDoc: IOption[] = [
        {
            id: '1',
            label: 'DNI',
        },
        {
            id: '2',
            label: 'LE',
        },
        {
            id: '3',
            label: 'LC',
        },
        {
            id: '4',
            label: 'Pasaporte',
        }
    ];

    const sexo: IOption[] = [
        {
            id: '1',
            label: 'Masculino',
        },
        {
            id: '2',
            label: 'Femenino',
        },
        {
            id: '3',
            label: 'Otro',
        }
    ];

    if (loading) {
        return <LoadingComponent />;
    }

    return (
        <VStack>
            <form onSubmit={handleSubmit(onSubmit)}>
                <VStack paddingLeft={['20px', '20px', '20px', '0px']} paddingRight={['20px', '20px', '20px', '0px']} width={'100%'}>
                    <Heading level={3} mb={'10px'} fontWeight={400} tabIndex={0}>
                        Datos Generales
                    </Heading>

                    <Input control={control} name={'nombreApellido'} placeholder='Apellido y Nombres (*)' />

                    <Select control={control} name={'tipoDoc'} placeholder='Tipo de Documento (*)' options={tipoDoc} style={{ height: '35px' }} />

                    <Input control={control} name={'dni'} placeholder='Número de Documento (*)' />

                    <Select control={control} name={'sexo'} placeholder='Sexo' options={sexo} style={{ height: '35px' }} />

                    <Input control={control} name={'fechaNac'} placeholder='Fecha de nacimiento (dd/mm/aaaa)' />

                    <Input control={control} name={'nroFijo'} placeholder='Teléfono Fijo (Cód.Area/N)' />

                    <Input control={control} name={'celular'} placeholder='Teléfono Celular' />

                    <Input control={control} name={'email'} placeholder='Email (*)' />

                    <Select control={control} name={'hsContactoDesde'} placeholder='desde' options={hsContacto} label={'Hs de contacto desde'} />

                    <Select control={control} name={'hsContactoHasta'} placeholder='hasta' options={hsContacto} label={'Hasta'} />

                    <Input control={control} name={'medioDeContacto'} placeholder='Medio preferido de contacto' />

                    <TextArea control={control} name={'mensaje'} placeholder='Mensaje (*)' rows={5} />

                    <Input type='checkbox' label="¿Desea recibir novedades por email?" control={control} name="siNovedades" />

                    <Input type='checkbox' label="¿Es cliente del banco?" control={control} name="siClienteBanco" />

                </VStack>

                <Box marginBottom={'20px'} display={'flex'} justifyContent={'center'}>
                    <Button
                        type="submit"
                        variant="secondary"
                        width={'244px !important'}>
                        Enviar Consulta
                    </Button>
                </Box>

                {openModal && (
                    <Modal
                        show={openModal}
                        title="Consulta por oportunidades inmobiliarias"
                        showConfirmButton={success ? true : false}
                        confirmLabel="Volver"
                        onConfirm={() => {
                            setOpenModal(false);
                            navigate('/Detalle/' + idInmueble);
                        }}
                        showCancelButton={success ? false : true}
                        cancelLabel="Cerrar"
                        onCancel={() => setOpenModal(false)}
                    >
                        {success ? (
                            <Text>Tu consulta fue enviada correctamente.</Text>
                        ) : (
                            <Text>Error al enviar la consulta. Por favor, intente nuevamente.</Text>
                        )}
                    </Modal>
                )}
            </form>
        </VStack>
    );
}